import { Text } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';

interface MultiLineDiscountProps {
  data?: any;
}

const MultiLineDiscount = ({ data }: MultiLineDiscountProps) => {
  const remarks = data?.remarks || [];

  const headers = ['Remarks'];
  const rows = [
    [
      <Text color="gray.400" fontStyle="italic" fontSize="sm">
        {remarks}
      </Text>,
    ],
  ];

  return (
    <>
      <DataTableCard headers={headers} rows={rows} />
    </>
  );
};

export default MultiLineDiscount;
